interface Event {
    title: string,
    influence: {symbol: string|null, amount: number, startsIn: number, endsIn: number}
}

interface StrategyEvent extends Event {
    cost: number,
    active: boolean
}

interface NewsEvent extends Event {
    thumbnail: string,
    description: string,
    topic: string
}

const NO_INFLUENCE = {
    symbol: null,
    amount: 0,
    startsIn: 0,
    endsIn: Infinity
}

const news: NewsEvent[] = [
    {
        thumbnail: '/assets/thumbnails/thumb-3.png',
        title: 'US Is Facing A Shortage Of Toilet Paper, And Now Also Newspapers',
        description: 'us is facing a shortage of toilet paper and now also newspapers',
        influence: NO_INFLUENCE,
        topic: 'USA'
    },
    {
        thumbnail: '/assets/thumbnails/thumb-4.png',
        title: 'How A Man Convinced A Crowd He Is Actually A Cat',
        description: 'how a man convinced a crowd he is actually a cat',
        influence: NO_INFLUENCE,
        topic: 'Opinions'
    },
    {
        thumbnail: '/assets/thumbnails/thumb-5.png',
        title: 'This Town In America Has Decided On Building A Huge Dome Over Itself',
        description: 'this town in america has decided on building a huge dome over itself',
        influence: NO_INFLUENCE,
        topic: 'Ideas'
    },
    {
        thumbnail: '/assets/thumbnails/thumb-6.png',
        title: 'Autonomous Cars Now Have To Attend An Ethical Philosophy Course',
        description: 'autonomous cars now have to attend an ethical philosophy course',
        influence: NO_INFLUENCE,
        topic: 'Tech'
    }
];

const events: NewsEvent[] = [
    {
        thumbnail: '/assets/thumbnails/thumb-1.png',
        title: 'Egon Busk Tweets Something Moronic About Memes',
        description: 'egon busk tweets something moronic about memes',
        influence: {symbol: 'MSLA', amount: -0.005, startsIn: 1, endsIn: 50},
        topic: 'Twitter'
    },
    {
        thumbnail: '/assets/thumbnails/thumb-2.png',
        title: 'Badimir Mutin Declares War To Some NATO Nation',
        description: 'badimir mutin declares war to some nation',
        influence: {symbol: 'BR500', amount: -0.005, startsIn: 1, endsIn: 50},
        topic: 'World'
    },
    {
        thumbnail: '/assets/thumbnails/thumb-7.png',
        title: 'Dipcoin Has Been Banned In China',
        description: 'dipcoin has been banned in china',
        influence: {symbol: 'DPC', amount: -0.005, startsIn: 1, endsIn: 50},
        topic: 'Crypto'
    },
    {
        thumbnail: '/assets/thumbnails/thumb-8.png',
        title: 'Egon Busk Presents A Humanoid Robot We Will Never Buy',
        description: 'egon busk presents a humanoid robot we will never buy',
        influence: {symbol: 'MSLA', amount: +0.005, startsIn: 1, endsIn: 50},
        topic: 'Mesla'
    },
    {
        thumbnail: '/assets/thumbnails/thumb-9.png',
        title: 'The World Is Collapsing Because Of A Bat',
        description: 'the world is collapsing because of a bat',
        influence: {symbol: 'BR500', amount: -0.005, startsIn: 1, endsIn: 80},
        topic: 'World'
    },
    {
        thumbnail: '/assets/thumbnails/thumb-10.png',
        title: 'Dipcoin Is Gonna Reach 1M$, Trust Me Bro',
        description: 'dipcoin is gonna reach 1 million dollars trust me bro',
        influence: {symbol: 'DPC', amount: +0.005, startsIn: 1, endsIn: 50},
        topic: 'Crypto'
    },
    {
        thumbnail: '/assets/thumbnails/thumb-12.png',
        title: 'Invidia Releases Its Latest GPUs, They Cost Just Like A Car',
        description: 'invidia releases its latest gpus they cost just like a car',
        influence: {symbol: 'INVD', amount: +0.005, startsIn: 1, endsIn: 30},
        topic: 'Tech'
    },
    {
        thumbnail: '/assets/thumbnails/thumb-13.png',
        title: 'SMD Releases Its Latest GPUs, And They Also Cost Less Than Invidia\'s',
        description: 'smd releases its latest gpus and they also cost less than invidias',
        influence: {symbol: 'SMD', amount: +0.005, startsIn: 1, endsIn: 30},
        topic: 'Tech'
    },
];

const strategies: StrategyEvent[] = [
    {
        title: 'Launch A TocToc Campaign To Influence Dumb Kids Into Buying Dipcoin',
        influence: {symbol: 'DPC', amount: 0.02, startsIn: 10, endsIn: 30},
        cost: 30000,
        active: false
    },
    {
        title: 'Buy A Swarm Of Twitter Bots To Pump Mesla Stock',
        influence: {symbol: 'MESLA', amount: 0.02, startsIn: 20, endsIn: 30},
        cost: 30000,
        active: false
    },
    {
        title: 'Buy A Swarm Of Twitter Bots To Shill Mesla Stock',
        influence: {symbol: 'MESLA', amount: -0.02, startsIn: 20, endsIn: 30},
        cost: 30000,
        active: false
    }
];

export type {Event, NewsEvent, StrategyEvent};
export {events, news, strategies};